import "../../scss/styles.scss";
import {
	displayNewslettersSummarySettings,
	displaySummarySettings,
	switchActive,
} from "./account-management/alerts";
import { initDeleteFavoriteListItem } from "./account-management/favorites/deleteItem";
import { initManageFavoriteLists } from "./account-management/favorites/manageFavoritesLists";
import { editRegion } from "./account-management/regions/editRegion";
import { initCapacitiesSelection } from "./capacities";
import { getJobDescription } from "./careers/getJobDescription";
import { getJobsLocations } from "./careers/getJobsLocations";
import { initDepartmentsTabs } from "./careers/initDepartmentsTabs";
import { initOpenPositions } from "./careers/initOpenPositions";
import { scrollIntoView } from "./careers/scrollIntoView";
import { accordion } from "./common/accordion";
import { adsViews } from "./common/adsViews";
import { initDropdowns } from "./common/dropdowns";
import { initFavorites } from "./common/favorites/favorites";
import { initModals } from "./common/modals";
import { initToggles } from "./common/toggle";
import { addOverlay } from "./common/utils";
import { displayForecastingDisclaimer } from "./displayForecastingDisclaimer";
import { initFeedbackPopup } from "./feedback-popup";
import { initFinancialsData } from "./financials";
import { formErrorClear } from "./formErrorClear";
import { initUI } from "./general";
import { initSwiper } from "./initSwiper";
import {
	handleModuleSelection,
	handleOrganisationModuleSelection,
} from "./moduleSelect";
import { addViewAllNewsButton } from "./profile/addViewAllNewsButton";
import { newsletterSettingsSelection } from "./newsletterSettingsSelection";
import { initProfile } from "./profile/profile";
import { startTimer } from "./resendEmailTimer";
import { initSentryConfig } from "./sentry";
import { sessions } from "./sessions";
import { setupSearchInDropdown } from "./setupSearchInDropdown";
import { initSinglePage } from "./profile/singleProfilePage";
import { subscribe } from "./subscribe";
import { updatePrices } from "./subscription";
import { initDropdownKeyTracking } from "./trackDropdownKey";
import { initHome } from "./home";
import { copyLink } from "./copyLink";
import { disableInputOnRadioChange } from "./profile/disableInputOnRadioChange";

// Global
window.initUI = initUI;
window.initModals = initModals;
window.initDropdowns = initDropdowns;
window.initToggles = initToggles;
window.initSinglePage = initSinglePage;
window.initFeedbackPopup = initFeedbackPopup;
window.initSwiper = initSwiper;
window.initFavorites = initFavorites;
window.initSentryConfig = initSentryConfig;
window.updatePrices = updatePrices;
window.editRegion = editRegion;
window.sessions = sessions;
window.subscribe = subscribe;
window.formErrorClear = formErrorClear;
window.initDropdownKeyTracking = initDropdownKeyTracking;
window.setupSearchInDropdown = setupSearchInDropdown;
window.startTimer = startTimer;
window.accordion = accordion;
window.addOverlay = addOverlay;
window.scrollIntoView = scrollIntoView;
window.copyLink = copyLink;

// Home
window.initHome = initHome;

// Profile pages
window.initProfile = initProfile;
window.addViewAllNewsButton = addViewAllNewsButton;
window.initCapacitiesSelection = initCapacitiesSelection;
window.initFinancialsData = initFinancialsData;
window.displayForecastingDisclaimer = displayForecastingDisclaimer;
window.disableInputOnRadioChange = disableInputOnRadioChange;

// Account management
window.switchActive = switchActive;
window.displaySummarySettings = displaySummarySettings;
window.displayNewslettersSummarySettings = displayNewslettersSummarySettings;
window.initManageFavoriteLists = initManageFavoriteLists;
window.initDeleteFavoriteListItem = initDeleteFavoriteListItem;

// Ads
window.adsViews = adsViews;

// Careers
window.initOpenPositions = initOpenPositions;
window.getJobDescription = getJobDescription;
window.getJobsLocations = getJobsLocations;
window.initDepartmentsTabs = initDepartmentsTabs;

// Module selection
window.handleModuleSelection = handleModuleSelection;
window.handleOrganisationModuleSelection = handleOrganisationModuleSelection;

// Newsletter setting selection
window.newsletterSettingsSelection = newsletterSettingsSelection;
